import { render, staticRenderFns } from "./TablaAmortizacion.vue?vue&type=template&id=20ed1621&"
import script from "./TablaAmortizacion.vue?vue&type=script&lang=js&"
export * from "./TablaAmortizacion.vue?vue&type=script&lang=js&"
import style0 from "./TablaAmortizacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports